import React, { useState, useEffect } from 'react';

const RadioGroup = ({
  items = [],
  optionType = 'default',
  size = 'md',
  fontWeight = 'md',
  direction = 'horizontal',
  invertPosition = false,
  value,
  onChange
}) => {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);

  const handleClick = (item) => {
    setCurrentValue(item.value);
    if (onChange) {
      onChange(item.value);
    }
  };

  return (
    <div>
      <div
        className={`${
          direction === 'vertical' ? 'w-full flex flex-col' : 'h-full flex flex-row'
        } ${optionType !== 'button' ? 'gap-y-4 gap-x-5 sm:gap-x-3 xs:gap-x-2' : ''}`}
      >
        {items.map((item, idx) => (
          <div key={idx} className="flex-shrink">
            <button
              type="button"
              className={`group flex flex-row items-center gap-x-2 focus:outline-none relative whitespace-nowrap ${
                optionType === 'button'
                  ? item.value === currentValue
                    ? 'border-primary z-10'
                    : 'border-secondary-border'
                  : ''
              } ${optionType === 'button' ? `w-full ${direction === 'vertical' ? 'px-2 py-1' : ''}` : ''} ${
                size === 'sm' ? 'text-sm' : size === 'md' ? 'text-base' : 'text-lg'
              }`}
              disabled={item.disabled === true}
              onClick={(e) => {
                e.preventDefault();
                handleClick(item);
              }}
            >
              <div
                className={`rounded-full bg-secondary-input border flex justify-center items-center ${
                  size === 'sm'
                    ? 'w-4 h-4'
                    : size === 'md'
                    ? 'w-5 h-5'
                    : size === 'lg'
                    ? 'w-6 h-6'
                    : size === 'xl'
                    ? 'w-8 xs:w-6 h-8 xs:h-6'
                    : ''
                } ${item.value === currentValue && item.disabled !== true ? 'border-primary' : ''}`}
              >
                {item.value === currentValue && (
                  <div
                    className={`rounded-full ${
                      size === 'sm'
                        ? 'w-2.5 h-2.5'
                        : size === 'md'
                        ? 'w-3 h-3'
                        : size === 'lg'
                        ? 'w-4 h-4'
                        : size === 'xl'
                        ? 'w-5 xs:w-4 h-5 xs:h-4'
                        : ''
                    } ${item.disabled !== true ? 'bg-primary' : 'bg-secondary-text-disabled'}`}
                  />
                )}
              </div>
              <div
                className={`flex flex-row items-center gap-x-1 ${
                  item.disabled === true ? 'text-secondary-text-disabled cursor-not-allowed' : ''
                } ${optionType === 'button' && item.value === currentValue ? 'text-primary' : ''}`}
              >
                {item.icon && (
                  <div
                    className={`${
                      size === 'sm'
                        ? 'w-4 h-4'
                        : size === 'md'
                        ? 'w-5 h-5'
                        : size === 'lg'
                        ? 'w-6 h-6'
                        : size === 'xl'
                        ? 'w-8 xs:w-6 h-8 xs:h-6'
                        : ''
                    }`}
                  >
                    <item.icon className="w-full h-full" />
                  </div>
                )}
                <div
                  className={`${
                    fontWeight === 'sm'
                      ? 'font-light'
                      : fontWeight === 'md'
                      ? 'font-normal'
                      : fontWeight === 'lg'
                      ? 'font-medium'
                      : 'font-semibold'
                  }`}
                >
                  {item.label}
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
